import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "subjects-v2",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "subjects-setup-v2" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
